'use client';

import styled from 'styled-components';

export function RatingWidget({
  rating,
  votesCount,
  submitted,
  onClick,
  error,
}: {
  rating: number;
  votesCount: number;
  submitted: boolean;
  onClick: (val: number) => void;
  error?: string | null;
}) {
  return (
    <Wrapper>
      <p>Rate this post:</p>

      <Content>
        <StarContainer>
          {[1, 2, 3, 4, 5].map((val) => (
            <StarButton
              key={val}
              onClick={() => onClick(val)}
              disabled={submitted || !!error}
              className={rating && val <= rating ? 'active' : ''}
            >
              ★
            </StarButton>
          ))}
        </StarContainer>

        <Stats>
          <span>{rating} / 5</span>
          <span>({votesCount} votes)</span>
        </Stats>

        {submitted && <SuccessMessage>Thanks for rating!</SuccessMessage>}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Content = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const Stats = styled.p`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const StarContainer = styled.div`
  display: inline-flex;
  direction: ltr;

  &:hover button {
    color: gold;
  }

  /* Reverse logic to highlight hovered + previous */
  button:hover ~ button {
    color: gray !important;
  }
`;

const StarButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  color: gray;
  cursor: pointer;
  padding: 0 4px;
  transition: color 0.2s;

  &.active {
    color: gold;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const SuccessMessage = styled.p`
  color: #22c55e;
  font-size: 14px;
  margin: 0;
`;

const ErrorMessage = styled.p`
  color: #ef4444;
  font-size: 14px;
  margin: 0;
`;
